<template>
  <div id="app">
    <router-view v-title="'KYC Verification'"></router-view>
    <AppStandardSnackbar
      v-model="$store.state.kycLogin.showNotification"
      @onClickNotification="hideNotification({showNotification:false})"
      :text="notificationMessage"
      :timeout="5000"
    />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { mapState } from "vuex";

import AppStandardSnackbar from "./commons/snackbar/AppStandardSnackbar.vue";
export default {
  name: "app",

  components: {
    AppStandardSnackbar
  },
  methods: {
    ...mapMutations({
      hideNotification: "SHOW_NOTIFICATION"
    })
  },
  computed: mapState({
    notificationMessage: state => state.kycLogin.notificationMessage
  })
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Roboto&display=swap");
* {
  font-family: "Roboto", sans-serif;
}
.b-global__button {
  margin: 35px !important;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #03b9f5;
  line-height: 3em;
  height: 3em;
  cursor: pointer;
}
.b-global__button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  margin: 35px !important;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #cccccc;
  color: #666666;
  line-height: 3em;
  height: 3em;
  cursor: not-allowed;
}
.loader {
  position: absolute;
  top: 25%;
  right: 46%;
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
